export default __webpack_public_path__ + "static/media/react.a0dab39a.svg";